/*
  <stelbo-parallax> — intrarea decalata a textului si deplasarea imaginii.

  Doua reguli care tin lucrul asta fluid:
  1. Se scrie DOAR pe `transform`. Nimic din ce face fisierul asta nu declanseaza
     reflow, deci nu exista CLS.
  2. Bucla rAF porneste doar cat timp sectiunea e in viewport (IntersectionObserver)
     si se opreste cand iese. Un listener de scroll global care ruleaza pe toata
     pagina ar consuma cadre degeaba.

  Parallaxul e oprit sub 990px si cand `prefers-reduced-motion` e activ. Intrarea
  decalata ramane in ambele cazuri, dar ca simpla aparitie, fara deplasare.
*/
(function () {
  if (customElements.get('stelbo-parallax')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  class StelboParallax extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-st-media]');
      this.reveals = Array.prototype.slice.call(
        this.querySelectorAll('[data-st-reveal]')
      );

      this._setupReveal();
      this._setupParallax();
    }

    disconnectedCallback() {
      this._stop();
      if (this.revealIO) this.revealIO.disconnect();
      if (this.io) this.io.disconnect();
      DESKTOP.removeEventListener('change', this._onMedia);
    }

    /* ---- intrarea decalata ---------------------------------------------- */

    _setupReveal() {
      if (!this.reveals.length) return;

      // Starea initiala se pune din JS: fara JS, textul trebuie sa fie vizibil.
      this.classList.add('st-fs--reveal-ready');

      var self = this;
      this.revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.classList.add('st-fs--revealed');
          self.revealIO.disconnect();
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

      this.revealIO.observe(this);
    }

    /* ---- parallax -------------------------------------------------------- */

    _setupParallax() {
      if (!this.media) return;
      this.shift = parseFloat(this.dataset.shift || '0');
      if (!this.shift) return;

      this._onMedia = this._evaluate.bind(this);
      DESKTOP.addEventListener('change', this._onMedia);
      REDUCED.addEventListener('change', this._onMedia);
      this._evaluate();
    }

    _evaluate() {
      var wanted = DESKTOP.matches && !REDUCED.matches;
      if (wanted && !this.io) {
        var self = this;
        this.io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { self._start(); } else { self._stop(); }
        }, { threshold: 0 });
        this.io.observe(this);
      } else if (!wanted) {
        this._stop();
        if (this.io) { this.io.disconnect(); this.io = null; }
        this.media.style.transform = '';
      }
    }

    _start() {
      if (this.raf) return;
      var self = this;
      var tick = function () {
        self._apply();
        self.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }

    _stop() {
      if (this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }

    _apply() {
      var rect = this.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var span = rect.height + vh;
      if (span <= 0) return;

      // 0 cand sectiunea tocmai intra de jos, 1 cand tocmai iese pe sus.
      var progress = (vh - rect.top) / span;
      progress = Math.min(1, Math.max(0, progress));

      // Centrat pe 0: imaginea urca la fel de mult cat coboara.
      var y = (progress - 0.5) * -2 * this.shift;
      this.media.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
    }
  }

  customElements.define('stelbo-parallax', StelboParallax);
})();
